import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Button,
  MenuItem,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { tokens } from "../../../../../theme";
import { useTheme } from "@mui/material";
import { getAuth } from "firebase/auth";
import CommentIcon from "@mui/icons-material/Comment";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SecurityIcon from "@mui/icons-material/Security";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const JobDetails = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(true);
  const [application, setApplication] = useState([]);
  const [newCommentText, setNewCommentText] = useState("");
  const [isAddingComment, setIsAddingComment] = useState(false);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("basic");
  const [openConvertDialog, setOpenConvertDialog] = useState(false);
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [employeePassword, setEmployeePassword] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [branchId, setBranchId] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [converting, setConverting] = useState(false);
  const [confirmedStatus, setConfirmedStatus] = useState("");
  const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
    ?.stsTokenManager?.accessToken;
  const [emergencyLeave, setEmergencyLeave] = useState(0); // Default to 0
  const [plannedLeave, setPlannedLeave] = useState(0); // Default to 0
  const [leaveLoading, setLeaveLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [signedUrlExpiry, setSignedUrlExpiry] = useState(null);
  const [visualStatusLabel, setVisualStatusLabel] = useState(
    application.status
  );
  const [responseLabelTimer, setResponseLabelTimer] = useState(null);
  const [initialStatus, setInitialStatus] = useState(application.status);
  const [actualStatus, setActualStatus] = useState(null);
  const [previewError, setPreviewError] = useState(false);
  const statusOptions = {
    New: ["Hold", "Shortlisted", "Rejected"],
    Pending: ["Shortlisted", "Rejected", "Selected"],
    Hold: ["Rejected", "Shortlisted", "Interview", "Selected"],
    Shortlisted: ["Hold", "Interview", "ResponseAwaited", "Pending"],
    Interview: [
      "Hold",
      "SecondOpinion",
      "ResponseAwaited",
      "Rejected",
      "Selected",
    ],
    SecondOpinion: ["ResponseAwaited", "Rejected", "Interview"],
    Selected: ["Hold", "ResponseAwaited", "Offered"],
    Offered: ["ResponseAwaited", "Onboarding", "NotJoined"],
    Onboarding: ["ResponseAwaited", "Hold"],
    ResponseAwaited: ["Interview", "Selected", "Offered"],
  };
  const [signedUrlMap, setSignedUrlMap] = useState({});
  const autoMapToResponseStatuses = [
    "Shortlisted",
    "Interview",
    "Selected",
    "Offered",
    "Onboarding",
  ];
  const displayLabelMap = {
    Pending: "Pending",
  };

  const tabFieldMap = {
    basic: [
      "name",
      "job_title",
      "mobile_no",
      "source",
      "status",
      "email",
      "current_ctc",
      "expected_ctc",
      "cv",
      "current_city",
      "native_place",
      "highestQualification",
    ],
    "Job Preferences": [
      "name",
      "Do_you_want_to_work_with_a_small_org",
      "Roles_and_responsibilities",
      "Why_apply",
      "Five_year_goal",
      "Preferred_Location",
      "current_ctc",
      "Current_Take_Home_Monthly",
      "expected_ctc",
      "Expected_CTC_Negotiable",
      "Total_Experience",
      "Relevant_Experience",
      "Earliest_Joining_days",
      "Holding_other_offer",
      "highestQualification",
      "professionalReference1",
      "referencenumber1",
      "referenceemail1",
      "professionalReference2",
      "renferencenumber2",
      "referenceemail2",
      "Describe_yourself",
      "Introduction_video",
    ],
    Documents: [
      "latestPaySlip",
      "lastAppointmentLetter",
      "degreeCertificate",
      "identityProof",
      "photograph",
      "lastEmployerRelievingLetter",
      "lastEmployerExperienceLetter",
      "aadharCard",
      "panCard",
    ],
    "Employee Information": [
      "legalName",
      "gender",
      "dateOfBirth",
      "maritalStatus",
      "languagesKnown",
      "presentAddress",
      "permanentAddress",
      "nativePlace",
      "collegeName",
      "universityName",
      "yearOfPassing",
      "keySkills",
      "lastEmployerRelievingDate",
      "bloodGroup",
      "emergencyContact1",
      "relation1",
      "emergencyContactNumber1",
      "emergencyContact2",
      "relation2",
      "emergencyContactNumber2",
      "familyContactNumber",
    ],
  };

  const getLeaveCalculationTableData = () => {
    if (!joiningDate) {
      return { canCalculate: false, joiningDateFormatted: "", data: [] };
    }

    const joinDate = new Date(joiningDate);
    const currentYear = joinDate.getFullYear();

    // Format the joining date for display
    const joiningDateFormatted = joinDate.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });

    // If joining date is not in the current year, we can't calculate accurately
    if (currentYear !== 2025) {
      return { canCalculate: false, joiningDateFormatted, data: [] };
    }

    const getQuarter = (date) => {
      const month = date.getMonth() + 1; // getMonth() returns 0-11
      if (month <= 3) return 1;
      if (month <= 6) return 2;
      if (month <= 9) return 3;
      return 4;
    };

    // Helper function to get half-year from date
    const getHalfYear = (date) => {
      const month = date.getMonth() + 1;
      return month <= 6 ? 1 : 2;
    };

    // Calculate days since quarter start
    const quarter = getQuarter(joinDate);
    const quarterStartDates = {
      1: new Date(currentYear, 0, 1), // Jan 1
      2: new Date(currentYear, 3, 1), // Apr 1
      3: new Date(currentYear, 6, 1), // Jul 1
      4: new Date(currentYear, 9, 1), // Oct 1
    };
    const quarterStart = quarterStartDates[quarter];
    const daysSinceQuarterStart =
      Math.floor((joinDate - quarterStart) / (1000 * 60 * 60 * 24)) + 1;

    // Calculate PL for current quarter based on days since quarter start
    let currentQuarterPL = 0;
    if (daysSinceQuarterStart >= 1 && daysSinceQuarterStart <= 22) {
      currentQuarterPL = 4;
    } else if (daysSinceQuarterStart >= 23 && daysSinceQuarterStart <= 45) {
      currentQuarterPL = 3;
    } else if (daysSinceQuarterStart >= 46 && daysSinceQuarterStart <= 67) {
      currentQuarterPL = 2;
    } else if (daysSinceQuarterStart >= 68 && daysSinceQuarterStart <= 90) {
      currentQuarterPL = 1;
    }

    // Calculate remaining quarters and their PL
    const remainingQuarters = 4 - quarter;
    const remainingQuartersPL = remainingQuarters * 4;
    const totalPL = currentQuarterPL + remainingQuartersPL;

    // Calculate days since half-year start
    const halfYear = getHalfYear(joinDate);
    const halfYearStartDates = {
      1: new Date(currentYear, 0, 1), // Jan 1
      2: new Date(currentYear, 6, 1), // Jul 1
    };
    const halfYearStart = halfYearStartDates[halfYear];
    const daysSinceHalfYearStart =
      Math.floor((joinDate - halfYearStart) / (1000 * 60 * 60 * 24)) + 1;

    // Calculate EL for current half-year based on days since half-year start
    let currentHalfYearEL = 0;
    if (daysSinceHalfYearStart >= 1 && daysSinceHalfYearStart <= 45) {
      currentHalfYearEL = 2.5;
    } else if (daysSinceHalfYearStart >= 46 && daysSinceHalfYearStart <= 90) {
      currentHalfYearEL = 1.5;
    } else if (daysSinceHalfYearStart >= 91 && daysSinceHalfYearStart <= 135) {
      currentHalfYearEL = 1;
    } else if (daysSinceHalfYearStart >= 136 && daysSinceHalfYearStart <= 180) {
      currentHalfYearEL = 0.5; // Updated to 0.5 as per your requirement
    }

    // Calculate remaining half-years and their EL
    const remainingHalfYears = 2 - halfYear;
    const remainingHalfYearsEL = remainingHalfYears * 2.5;
    const totalEL = currentHalfYearEL + remainingHalfYearsEL;

    // Get quarter and half-year names for display
    const quarterNames = {
      1: "Q1 (Jan-Mar)",
      2: "Q2 (Apr-Jun)",
      3: "Q3 (Jul-Sep)",
      4: "Q4 (Oct-Dec)",
    };

    const halfYearNames = {
      1: "H1 (Jan-Jun)",
      2: "H2 (Jul-Dec)",
    };

    // PL Allocation Schema Data
    const plSchemaData = [
      { daysRange: "1 – 22", allocation: "4 PL" },
      { daysRange: "23 – 45", allocation: "3 PL" },
      { daysRange: "46 – 67", allocation: "2 PL" },
      { daysRange: "68 – 90", allocation: "1 PL" },
    ];

    // EL Allocation Schema Data
    const elSchemaData = [
      { daysRange: "1 – 45", allocation: "2.5 EL" },
      { daysRange: "46 – 90", allocation: "1.5 EL" },
      { daysRange: "91 – 135", allocation: "1 EL" },
      { daysRange: "136 – 180", allocation: "0.5 EL" },
    ];

    // Main table data showing actual calculation
    const data = [
      {
        leaveType: "Planned Leave (PL)",
        annual: "16 days",
        period: quarterNames[quarter],
        daysSincePeriodStart: daysSinceQuarterStart,
        allocationCurrent: `${currentQuarterPL} days`,
        remainingPeriods: remainingQuarters,
        allocationRemaining: `${remainingQuartersPL} days`,
        total: `${totalPL} days`,
      },
      {
        leaveType: "Emergency Leave (EL)",
        annual: "5 days",
        period: halfYearNames[halfYear],
        daysSincePeriodStart: daysSinceHalfYearStart,
        allocationCurrent: `${currentHalfYearEL} days`,
        remainingPeriods: remainingHalfYears,
        allocationRemaining: `${remainingHalfYearsEL} days`,
        total: `${totalEL} days`,
      },
    ];

    return {
      canCalculate: true,
      joiningDateFormatted,
      data,
      plSchemaData,
      elSchemaData,
    };
  };
  const getLeaveCalculationExplanation = () => {
    if (!joiningDate) {
      return "Not calculated yet. Please select a joining date.";
    }

    const joinDate = new Date(joiningDate);
    const currentYear = joinDate.getFullYear();

    // Format the joining date for display
    const formattedJoinDate = joinDate.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });

    // Calculate leaves
    const { plDetails, elDetails } = calculateLeaves(joiningDate);

    if (plDetails.note) {
      return plDetails.note;
    }

    return (
      <>
        Based on your joining date: <strong>{formattedJoinDate}</strong>
        <br />
        <strong>Planned Leave (PL):</strong>
        <br />
        - Total annual PL: 16 days (4 days per quarter)
        <br />- Joining quarter: {plDetails.quarter}
        <br />- Days since quarter start: {plDetails.daysSinceQuarterStart}
        <br />- PL for joining quarter: {plDetails.currentQuarterPL} days
        <br />- Remaining quarters: {plDetails.remainingQuarters}
        <br />- PL for remaining quarters: {plDetails.remainingQuartersPL} days
        <br />- Total PL: <strong>{plannedLeave} days</strong>
        <br />
        <br />
        <strong>Emergency Leave (EL):</strong>
        <br />
        - Total annual EL: 5 days (2.5 days per half-year)
        <br />- Joining half-year: {elDetails.halfYear}
        <br />- Days since half-year start: {elDetails.daysSinceHalfYearStart}
        <br />- EL for joining half-year: {elDetails.currentHalfYearEL} days
        <br />- Remaining half-years: {elDetails.remainingHalfYears}
        <br />- EL for remaining half-year: {
          elDetails.remainingHalfYearsEL
        }{" "}
        days
        <br />- Total EL: <strong>{emergencyLeave} days</strong>
      </>
    );
  };
  const calculateLeaves = (joiningDate) => {
    if (!joiningDate) {
      return { pl: 0, el: 0, plDetails: {}, elDetails: {} };
    }

    const joinDate = new Date(joiningDate);
    const currentYear = joinDate.getFullYear();
    const joinMonth = joinDate.getMonth(); // 0-11 (Jan-Dec)
    const joinDay = joinDate.getDate();
    const joinYear = joinDate.getFullYear();

    // Ensure the joining date is in the current year (2025)
    if (joinYear !== 2025) {
      return {
        pl: 0,
        el: 0,
        plDetails: {
          note: "Calculation available only for the current year (2025).",
        },
        elDetails: {},
      };
    }

    // Helper to calculate days between two dates
    const daysBetween = (startDate, endDate) => {
      const oneDay = 1000 * 60 * 60 * 24;
      return Math.round((endDate - startDate) / oneDay) + 1; // +1 to include the start day
    };

    // --- Planned Leave (PL) Calculation ---
    const quarters = [
      {
        start: new Date(currentYear, 0, 1),
        end: new Date(currentYear, 2, 31),
        days: 90,
      }, // Q1: Jan-Mar
      {
        start: new Date(currentYear, 3, 1),
        end: new Date(currentYear, 5, 30),
        days: 91,
      }, // Q2: Apr-Jun
      {
        start: new Date(currentYear, 6, 1),
        end: new Date(currentYear, 8, 30),
        days: 92,
      }, // Q3: Jul-Sep
      {
        start: new Date(currentYear, 9, 1),
        end: new Date(currentYear, 11, 31),
        days: 92,
      }, // Q4: Oct-Dec
    ];

    let pl = 0;
    let plDetails = {
      quarter: "",
      daysSinceQuarterStart: 0,
      currentQuarterPL: 0,
      remainingQuarters: 0,
      remainingQuartersPL: 0,
    };

    // Find the joining quarter
    const joinQuarterIndex = quarters.findIndex(
      (q) => joinDate >= q.start && joinDate <= q.end
    );

    if (joinQuarterIndex !== -1) {
      const quarter = quarters[joinQuarterIndex];
      const daysSinceQuarterStart = daysBetween(quarter.start, joinDate);

      // PL allocation for the joining quarter
      let currentQuarterPL = 0;
      if (daysSinceQuarterStart >= 1 && daysSinceQuarterStart <= 22) {
        currentQuarterPL = 4;
      } else if (daysSinceQuarterStart <= 45) {
        currentQuarterPL = 3;
      } else if (daysSinceQuarterStart <= 67) {
        currentQuarterPL = 2;
      } else if (daysSinceQuarterStart <= 90) {
        currentQuarterPL = 1;
      }

      // PL for remaining quarters
      const remainingQuarters = 3 - joinQuarterIndex; // Number of quarters left after the joining quarter
      const remainingQuartersPL = remainingQuarters * 4; // 4 PL per quarter

      // Total PL
      pl = currentQuarterPL + remainingQuartersPL;

      // Store details for explanation and table
      plDetails = {
        quarter: `Q${joinQuarterIndex + 1}`,
        daysSinceQuarterStart,
        currentQuarterPL,
        remainingQuarters,
        remainingQuartersPL,
      };
    }

    // --- Emergency Leave (EL) Calculation ---
    const halfYears = [
      {
        start: new Date(currentYear, 0, 1),
        end: new Date(currentYear, 5, 30),
        days: 181,
      }, // Jan-Jun
      {
        start: new Date(currentYear, 6, 1),
        end: new Date(currentYear, 11, 31),
        days: 184,
      }, // Jul-Dec
    ];

    let el = 0;
    let elDetails = {
      halfYear: "",
      daysSinceHalfYearStart: 0,
      currentHalfYearEL: 0,
      remainingHalfYears: 0,
      remainingHalfYearsEL: 0,
    };

    // Find the joining half-year
    const joinHalfYearIndex = halfYears.findIndex(
      (h) => joinDate >= h.start && joinDate <= h.end
    );

    if (joinHalfYearIndex !== -1) {
      const halfYear = halfYears[joinHalfYearIndex];
      const daysSinceHalfYearStart = daysBetween(halfYear.start, joinDate);

      // EL allocation for the joining half-year
      let currentHalfYearEL = 0;
      if (daysSinceHalfYearStart >= 1 && daysSinceHalfYearStart <= 45) {
        currentHalfYearEL = 2.5;
      } else if (daysSinceHalfYearStart <= 90) {
        currentHalfYearEL = 1.5;
      } else if (daysSinceHalfYearStart <= 135) {
        currentHalfYearEL = 1;
      } else if (daysSinceHalfYearStart <= 180) {
        currentHalfYearEL = 0.5;
      }

      // EL for remaining half-year
      const remainingHalfYears = 1 - joinHalfYearIndex; // Number of half-years left (0 or 1)
      const remainingHalfYearsEL = remainingHalfYears * 2.5; // 2.5 EL per half-year

      // Total EL
      el = currentHalfYearEL + remainingHalfYearsEL;

      // Store details for explanation and table
      elDetails = {
        halfYear: joinHalfYearIndex === 0 ? "Jan–Jun" : "Jul–Dec",
        daysSinceHalfYearStart,
        currentHalfYearEL,
        remainingHalfYears,
        remainingHalfYearsEL,
      };
    }

    return { pl, el, plDetails, elDetails };
  };
  const fetchApplication = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/job_application/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const data = await response.json();

      if (response.ok) {
        setApplication(data);
        setConfirmedStatus(data.status);
        setActualStatus(data.actual_status || data.status);
      } else {
        console.error("Error:", data.error);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchApplication();
  }, [id]);

  useEffect(() => {
    if (application) {
    }
  }, [application]);

  useEffect(() => {
    const fetchLeaveCalculation = async () => {
      if (!joiningDate) {
        // Reset leaves to 0 if no joining date is selected
        setEmergencyLeave(0);
        setPlannedLeave(0);
        return;
      } // Skip if no joining date

      setLeaveLoading(true);
      try {
        // Format joiningDate to mm/dd/yyyy
        const formattedDate = new Date(joiningDate).toLocaleDateString(
          "en-US",
          {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          }
        );

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/calculate-leave`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
              joining_date: formattedDate,
            }),
          }
        );

        const data = await response.json();
        if (response.ok) {
          setEmergencyLeave(data.emergency_leave.total || 0);
          setPlannedLeave(data.planned_leave.total || 0);
        } else {
          console.error("Error calculating leaves:", data.error);
          setEmergencyLeave(0);
          setPlannedLeave(0);
        }
      } catch (error) {
        console.error("Fetch leave calculation error:", error);
        setEmergencyLeave(0);
        setPlannedLeave(0);
      } finally {
        setLeaveLoading(false);
      }
    };

    fetchLeaveCalculation();
  }, [joiningDate, accessToken]);

  async function saveApplication() {
    setIsSaving(true); // Set saving state to true
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user || !user.email) {
      console.error("User not authenticated or email not found.");
      setIsSaving(false);
      return;
    }

    try {
      const updatedBy = user?.email || "Admin";
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/job-applications/update/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            comment: newCommentText,
            updated_by: updatedBy,
            status: application.status,
            name: application.name,
            job_title: application.job_title,
            email: application.email,
            app_id: application.id,
          }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        const savedStatus = application.status;
        setConfirmedStatus(savedStatus);
        setNewCommentText("");
        await fetchApplication();
        setVisualStatusLabel(savedStatus);
      } else {
        throw new Error(result.error || "Failed to update status");
      }
    } catch (err) {
      console.error("Error saving application:", err);
      setApplication((prev) => ({ ...prev, status: confirmedStatus }));
    } finally {
      setIsSaving(false); // Reset saving state
    }
  }

  async function handleAddComment() {
    if (!newCommentText || !newCommentText.trim()) {
      setDialogTitle("Validation Error");
      setDialogMessage("Please enter a comment before adding.");
      setDialogOpen(true);
      return;
    }

    setIsAddingComment(true);
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user || !user.email) {
      console.error("User not authenticated or email not found.");
      setDialogTitle("Authentication Error");
      setDialogMessage("User not authenticated or email not found.");
      setDialogOpen(true);
      setIsAddingComment(false);
      return;
    }

    try {
      const updatedBy = user?.email || "Admin";
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/job-applications/comments/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            comment: newCommentText.trim(),
            user: updatedBy,
          }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setNewCommentText("");
        setOpenCommentDialog(false);
        await fetchApplication();
        setSnackbarSeverity("success");
        setSnackbarMessage("Comment added successfully!");
        setSnackbarOpen(true);
      } else {
        throw new Error(result.error || "Failed to add comment");
      }
    } catch (err) {
      console.error("Error adding comment:", err);
      setSnackbarSeverity("error");
      setSnackbarMessage(err.message || "Failed to add comment.");
      setSnackbarOpen(true);
    } finally {
      setIsAddingComment(false);
    }
  }

  const handleCloseCommentDialog = () => {
    if (!isAddingComment) {
      setOpenCommentDialog(false);
      setNewCommentText("");
    }
  };

  useEffect(() => {
    setVisualStatusLabel(application.status);
  }, [application.status]);

  function BackApplication() {
    navigate("/job_application");
  }

  const getTimeAgo = (dateString) => {
    if (!dateString) return "Invalid date";

    // Normalize common variations
    const cleaned = dateString
      .replace(" at ", " ")
      .replace(" UTC+5:30", "") // safely remove time zone
      .trim();

    const parsedDate = new Date(cleaned);

    if (isNaN(parsedDate)) return "Invalid date";

    const now = new Date();
    const diffMs = now - parsedDate;

    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays > 0) return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
    if (diffHours > 0)
      return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
    if (diffMinutes > 0)
      return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
    if (diffSeconds >= 0) return "just now";

    return "just now";
  };

  // useEffect(() => {
  //   if (previewUrl) {
  //     setIsPreviewLoading(true);
  //     const timer = setTimeout(() => {
  //       setIsPreviewLoading(false);
  //     }, 500); // Simulate loading delay; adjust as needed

  //     return () => clearTimeout(timer);
  //   }
  // }, [previewUrl]);

  const getFileExtension = (url) => {
    try {
      const pathname = new URL(url).pathname;
      const filename = pathname.substring(pathname.lastIndexOf("/") + 1);
      const ext = filename.includes(".")
        ? filename.split(".").pop().toLowerCase()
        : "";
      return ext;
    } catch (e) {
      console.error("Error getting file extension:", e);
      return "";
    }
  };
  const imageTypes = ["png", "jpg", "jpeg", "gif", "bmp", "webp"];
  const videoTypes = ["mp4", "webm", "ogg", "mov", "avi", "mkv"];
  const textTypes = ["txt", "csv"];
  const previewWithGoogleDocs = [
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "csv",
    "txt",
    "ppt",
    "pptx",
  ];

  const renderPreview = (currentPreviewUrl) => {
    // console.log('renderPreview called with URL:', currentPreviewUrl);
    // console.log('isRefreshing:', isRefreshing, 'isPreviewLoading:', isPreviewLoading);

    // Show refreshing state first (highest priority)
    if (isRefreshing) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CircularProgress sx={{ color: colors.grey[100] }} />
          <Typography sx={{ color: colors.grey[100] }}>
            Refreshing...
          </Typography>
        </Box>
      );
    }

    // Show loading state
    if (currentPreviewUrl === "loading" || isPreviewLoading) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CircularProgress sx={{ color: colors.grey[100] }} />
          <Typography sx={{ color: colors.grey[100] }}>Loading...</Typography>
        </Box>
      );
    }

    if (!currentPreviewUrl) {
      // console.error('No URL provided for preview.');
      return <Typography>No file to preview.</Typography>;
    }

    const ext = getFileExtension(currentPreviewUrl);
    // console.log('Detected file extension:', ext);

    if (ext === "pdf") {
      // console.log('Rendering PDF with URL:', currentPreviewUrl);
      return (
        <Box sx={{ width: "100%", height: "100%" }}>
          <iframe
            src={currentPreviewUrl}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{
              minHeight: "600px",
              border: "none",
            }}
          >
            <Typography>PDF preview not supported in your browser.</Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              href={currentPreviewUrl}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              Download PDF
            </Button>
          </iframe>
        </Box>
      );
    }

    if (imageTypes.includes(ext)) {
      // console.log('Rendering image with URL:', currentPreviewUrl);
      return (
        <img
          src={currentPreviewUrl}
          alt="Preview"
          style={{ maxWidth: "100%", maxHeight: 400 }}
          onError={(e) => {
            console.error("Image load failed for URL:", currentPreviewUrl);
            e.target.style.display = "none";
            setDialogTitle("Error");
            setDialogMessage(
              "Failed to load image preview. Check the URL or file access."
            );
            setDialogOpen(true);
          }}
          onLoad={() => console.log("Image loaded successfully")}
        />
      );
    }

    if (videoTypes.includes(ext)) {
      // console.log('Rendering video with URL:', currentPreviewUrl);
      return (
        <video
          width="100%"
          height="100%"
          controls
          style={{ objectFit: "contain", maxHeight: "90%", width: "100%" }}
          onError={(e) => {
            console.error("Video load failed for URL:", currentPreviewUrl);
            e.target.style.display = "none";
            setDialogTitle("Error");
            setDialogMessage(
              "Failed to load video preview. Check the URL or file access."
            );
            setDialogOpen(true);
          }}
          onLoad={() => console.log("Video loaded successfully:")}
        >
          <source
            src={currentPreviewUrl}
            type={getVideoMimeType(currentPreviewUrl)}
          />
          Your browser does not support the video tag.
        </video>
      );
    }

    const googleDocsUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
      currentPreviewUrl
    )}&embedded=true`;
    // console.log('Rendering document with URL:', googleDocsUrl);
    return (
      <iframe
        src={googleDocsUrl}
        title="Document Preview"
        width="100%"
        height="600px"
        frameBorder="0"
        onError={() => {
          console.error("Document load failed for URL:", googleDocsUrl);
          setDialogTitle("Error");
          setDialogMessage("Failed to load document preview.");
          setDialogOpen(true);
        }}
      />
    );
  };

  const dbStatus = confirmedStatus || application.status;
  const baseStatus = actualStatus ?? dbStatus ?? "New";
  const currentStatus = baseStatus;

  const isFinal = initialStatus === "Rejected";
  const isEmployed = initialStatus === "Employeed";

  const nextStatuses = statusOptions[baseStatus] || [];

  const relatedPhases = Object.entries(statusOptions)
    .filter(([_, values]) => values.includes(currentStatus))
    .map(([phase]) => phase);

  const savedStatus = confirmedStatus || application.status;
  const isDropdownDisabled =
    savedStatus === "Rejected" || savedStatus === "Employeed";

  let combinedStatuses = [...new Set([...nextStatuses, ...relatedPhases])];

  if (!combinedStatuses.includes("New")) {
    combinedStatuses.push("New");
  }

  if (savedStatus === "Onboarding") {
    combinedStatuses = combinedStatuses.filter((s) => s !== "Offered");
  }

  const defaultNewStatuses = statusOptions["New"];

  const dropdownOptions = [
    {
      value: baseStatus,
      disabled: true,
    },
    ...(baseStatus === "Onboarding"
      ? []
      : (statusOptions[baseStatus] || defaultNewStatuses || []).map((s) => ({
        value: s,
        disabled: false,
      }))),
  ];

  if (baseStatus === "New" && dropdownOptions.length === 1) {
    dropdownOptions.push(
      ...["Hold", "Shortlisted", "Rejected"].map((s) => ({
        value: s,
        disabled: false,
      }))
    );
  }
  const extractFilePathFromUrl = (url) => {
    // console.log('extractFilePathFromUrl called with:', url);

    if (
      !url ||
      typeof url !== "string" ||
      url.trim() === "" ||
      url === "No File"
    ) {
      console.error("Invalid or empty URL:", url);
      return null;
    }

    try {
      if (url.startsWith("job_applications/")) {
        return url;
      }
      if (
        url.includes("storage.googleapis.com") ||
        url.includes("storage.cloud.google.com")
      ) {
        const urlObj = new URL(url);
        const pathParts = urlObj.pathname.split("/").filter((part) => part);
        if (pathParts.length > 1) {
          return pathParts.slice(1).join("/");
        }
        return urlObj.pathname.substring(1);
      }
      if (url.includes("firebasestorage.googleapis.com")) {
        const match = url.match(/\/v0\/b\/[^\/]+\/o\/(.+?)(?:\?|$)/);
        if (match && match[1]) {
          return decodeURIComponent(match[1]);
        }
      }
      if (url.startsWith("gs://")) {
        return url.replace("gs://", "").split("/").slice(1).join("/");
      }
      if (url.includes("/") && !url.includes("://")) {
        return url;
      }
      console.warn("Unrecognized URL format:", url);
      return null;
    } catch (error) {
      console.error("Error in extractFilePathFromUrl:", error, "URL:", url);
      return null;
    }
  };
  const extractExpiryFromSignedUrl = (signedUrl) => {
    try {
      const url = new URL(signedUrl);
      const xGoogDate = url.searchParams.get("X-Goog-Date");
      const xGoogExpires = url.searchParams.get("X-Goog-Expires");

      if (!xGoogDate || !xGoogExpires) {
        console.warn("Could not find expiry parameters in signed URL");
        return null;
      }

      // Parse the date (format: YYYYMMDDTHHMMSSZ)
      const year = parseInt(xGoogDate.substring(0, 4));
      const month = parseInt(xGoogDate.substring(4, 6)) - 1; // Month is 0-indexed
      const day = parseInt(xGoogDate.substring(6, 8));
      const hour = parseInt(xGoogDate.substring(9, 11));
      const minute = parseInt(xGoogDate.substring(11, 13));
      const second = parseInt(xGoogDate.substring(13, 15));

      const signedDate = new Date(
        Date.UTC(year, month, day, hour, minute, second)
      );
      const expiresInSeconds = parseInt(xGoogExpires);
      const expiresAt = new Date(
        signedDate.getTime() + expiresInSeconds * 1000
      );

      return expiresAt.toISOString();
    } catch (error) {
      console.error("Error extracting expiry from signed URL:", error);
      return null;
    }
  };
  const generateSignedUrl = async (filePath) => {
    if (!filePath) {
      console.error("No file path provided for signed URL generation");
      throw new Error("No file path provided");
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/generate-signed-url`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            file_path: filePath,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Failed to generate signed URL: ${
            errorData.message || response.statusText
          }`
        );
      }

      const data = await response.json();
      if (!data.signed_url) {
        throw new Error("No signed URL returned from the server");
      }

      // Extract expiry from the signed URL itself if not provided by server
      let expiresAt = data.expires_at;
      if (!expiresAt) {
        expiresAt = extractExpiryFromSignedUrl(data.signed_url);
        if (!expiresAt) {
          console.warn(
            "Could not determine expiry time, using default of 5 minutes"
          );
          expiresAt = new Date(Date.now() + 5 * 60 * 1000).toISOString();
        }
      }

      return { signedUrl: data.signed_url, expiresAt };
    } catch (error) {
      // console.error('Error generating signed URL:', error, 'File Path:', filePath);
      throw error;
    }
  };

  // Modified handleOpenModal - simplified since we're generating URL on demand
  const handleOpenModal = async (originalUrl) => {
    // console.log('handleOpenModal called with:', originalUrl);

    if (
      !originalUrl ||
      originalUrl === "No File" ||
      typeof originalUrl !== "string"
    ) {
      // console.error('Invalid URL:', originalUrl);
      setDialogTitle("Error");
      setDialogMessage("No file available to preview.");
      setDialogOpen(true);
      return;
    }

    try {
      setIsPreviewLoading(true);
      setOpenModal(true);
      setPreviewUrl("loading");

      // Check if the URL is already a signed URL
      if (originalUrl.includes("X-Goog-Algorithm")) {
        // console.log('URL is already a signed URL, extracting expiry');
        const expiresAt = extractExpiryFromSignedUrl(originalUrl);

        if (expiresAt) {
          const expiresAtMs = new Date(expiresAt).getTime();
          const now = Date.now();

          // If URL is still valid (not expired and more than 1 minute left)
          if (expiresAtMs > now + 60 * 1000) {
            // console.log('Using existing signed URL, expires at:', expiresAt);
            setPreviewUrl(originalUrl);
            setSignedUrlExpiry(expiresAt);
            setSignedUrlMap((prev) => ({
              ...prev,
              [originalUrl]: originalUrl,
            }));
            setIsPreviewLoading(false);
            return;
          }
        }
      }

      const filePath = extractFilePathFromUrl(originalUrl);
      if (!filePath) {
        throw new Error("Could not extract file path from the provided URL");
      }

      const { signedUrl, expiresAt } = await generateSignedUrl(filePath);
      // console.log('Generated signed URL:', signedUrl, 'Expires at:', expiresAt);

      if (!signedUrl) {
        throw new Error("Failed to generate signed URL");
      }

      setSignedUrlMap((prev) => ({ ...prev, [originalUrl]: signedUrl }));
      setPreviewUrl(signedUrl);
      setSignedUrlExpiry(expiresAt);
    } catch (error) {
      console.error("Error in handleOpenModal:", error);
      setPreviewUrl(null);
      setDialogTitle("Error");
      setDialogMessage(`Failed to load file preview: ${error.message}`);
      setDialogOpen(true);
    } finally {
      setIsPreviewLoading(false);
    }
  };

  // New effect to handle URL regeneration
  useEffect(() => {
    if (
      !signedUrlExpiry ||
      !previewUrl ||
      previewUrl === "loading" ||
      !openModal
    )
      return;

    const expiresAtMs = new Date(signedUrlExpiry).getTime();
    const now = Date.now();
    const oneMinuteBeforeExpiry = expiresAtMs - 60 * 1000; // 1 minute before expiry

    if (now >= oneMinuteBeforeExpiry) {
      // If already within 1 minute of expiry, regenerate immediately
      const regenerate = async () => {
        try {
          setIsRefreshing(true);

          // Extract original file path for regeneration
          let filePath = extractFilePathFromUrl(previewUrl);

          // If extraction fails, try to get it from the signed URL parameters
          if (!filePath && previewUrl.includes("job_applications/")) {
            const match = previewUrl.match(/job_applications\/[^?]+/);
            if (match) {
              filePath = match[0];
            }
          }

          if (!filePath) {
            throw new Error("Could not extract file path for regeneration");
          }

          const { signedUrl, expiresAt } = await generateSignedUrl(filePath);
          setSignedUrlMap((prev) => ({ ...prev, [previewUrl]: signedUrl }));
          setPreviewUrl(signedUrl);
          setSignedUrlExpiry(expiresAt);
        } catch (error) {
          console.error("Error regenerating signed URL:", error);
          setDialogTitle("Error");
          setDialogMessage("Failed to refresh file preview.");
          setDialogOpen(true);
        } finally {
          setIsRefreshing(false);
        }
      };
      regenerate();
    } else {
      // Schedule regeneration 1 minute before expiry
      const timeout = setTimeout(() => {
        const regenerate = async () => {
          try {
            setIsRefreshing(true);

            let filePath = extractFilePathFromUrl(previewUrl);

            if (!filePath && previewUrl.includes("job_applications/")) {
              const match = previewUrl.match(/job_applications\/[^?]+/);
              if (match) {
                filePath = match[0];
              }
            }

            if (!filePath) {
              throw new Error("Could not extract file path for regeneration");
            }

            const { signedUrl, expiresAt } = await generateSignedUrl(filePath);
            setSignedUrlMap((prev) => ({ ...prev, [previewUrl]: signedUrl }));
            setPreviewUrl(signedUrl);
            setSignedUrlExpiry(expiresAt);
          } catch (error) {
            console.error("Error regenerating signed URL:", error);
            setDialogTitle("Error");
            setDialogMessage("Failed to refresh file preview.");
            setDialogOpen(true);
          } finally {
            setIsRefreshing(false);
          }
        };
        regenerate();
      }, oneMinuteBeforeExpiry - now);

      return () => clearTimeout(timeout);
    }
  }, [signedUrlExpiry, previewUrl, openModal]);

  const handleCloseModal = () => {
    setOpenModal(false);
    setPreviewUrl("");
  };

  function getFileNameFromUrl(url) {
    if (
      url &&
      typeof url === "string" &&
      url.trim() !== "" &&
      url !== "No File"
    ) {
      return url.split("/").pop();
    }
    return "";
  }

  function getVideoMimeType(url) {
    const ext = getFileExtension(url);
    switch (ext) {
      case "mp4":
        return "video/mp4";
      case "webm":
        return "video/webm";
      case "ogg":
        return "video/ogg";
      case "mov":
        return "video/quicktime";
      case "avi":
        return "video/x-msvideo";
      case "mkv":
        return "video/x-matroska";
      default:
        return "video/mp4"; // fallback
    }
  }

  const applicationTabs = [
    { label: "Basic Info", key: "basic" },
    { label: "Job Preferences", key: "Job Preferences" },
    { label: "Documents", key: "Documents" },
    { label: "Employee Information", key: "Employee Information" },
  ];

  const getTabByField = (fieldName) => {
    for (const [tabKey, fields] of Object.entries(tabFieldMap)) {
      if (fields.includes(fieldName)) {
        return tabKey;
      }
    }
    return null;
  };

  const deleteEmployeeDataByEmail = async (email) => {
    const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
      ?.stsTokenManager?.accessToken;

    const cleanupEndpoint = `${process.env.REACT_APP_BACKEND_URL_HRM}/cleanup-employee-data`;

    const response = await fetch(cleanupEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ corporate_email_id: email }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Cleanup failed:", errorData.message);
    } else {
    }
  };

  const handleConvertToEmployee = async () => {
    try {
      setConverting(true);

      // 1. First validate required fields
      if (!employeeEmail || !employeePassword) {
        throw new Error("Email and password are required");
      }

      if (!joiningDate) {
        throw new Error("Joining date is required");
      }

      if (!branchId) {
        throw new Error("Branch selection is required");
      }

      const [firstName, ...rest] = application.name?.split(" ") || [];
      const personalDetailsPayload = {
        job_id: application.id,
        First_Name: firstName || "",
        Last_Name: application.Last_Name || "",
        Legalname: application.legalName || "",
        branch_id: branchId,
        PersonalMobileNumber: application.mobile_no || "",
        Personal_EmailID: application.email || "",
        corporate_email_id: employeeEmail,
        designation: application.job_title || "",
        BloodGroup: application.bloodGroup || "",
        gender: application.gender || "",
        date_of_birth: application.dateOfBirth || null,
        marital_status: application.maritalStatus || "",
        languages_known: application.languagesKnown || "",
        joining_date: joiningDate,
        employeeType: "Full Time",
        isAdmin: false,
        status: "Active",
        emergencyleave: 0,
        plannedleave: 0,
      };

      const addressPayload = {
        corporate_email_id: employeeEmail,
        permanent_address: application.permanentAddress || "",
        present_address: application.presentAddress || "",
        present_city: "",
        country: "India",
      };

      const emergencyContactPayload = {
        corporate_email_id: employeeEmail,
        emergency_contact_name1: application.emergencyContact1 || "",
        emergency_person_relation1: application.relation1 || "",
        emergency_contact_number1: application.emergencyContactNumber1 || "",
        emergency_contact_name2: application.emergencyContact2 || "",
        emergency_person_relation2: application.relation2 || "",
        emergency_contact_number2: application.emergencyContactNumber2 || "",
      };

      const documentPayload = {
        corporate_email_id: employeeEmail,
        passport_number: "",
        passport_expiry_date: "",
        aadhar_card: application.aadharCard || "",
        pan_card: application.panCard || "",
        photograph: application.photograph || "",
      };

      const qualificationPayload = {
        corporate_email_id: employeeEmail,
        college_name: application.collegeName || "",
        university_name: application.universityName || "",
        year_of_passing: application.yearOfPassing || "",
        uploaded_certificates: {
          degree_certificate: application.degreeCertificate || "",
        },
      };

      const workExperiencePayload = {
        corporate_email_id: employeeEmail,
        skill_sets: application.keySkills || "",
        professional_reference1: application.professionalReference1,
        professional_reference1_contact_number: application.referencenumber1,
        professional_reference2: application.professionalReference2,
        professional_reference2_contact_number: application.renferencenumber2,
        professional_reference2_email: application.referenceemail2,
        professional_reference1_email: application.referenceemail1,
        uploaded_files: {
          experience_certificate:
            application.lastEmployerExperienceLetter || "",
          relieving_letter: application.lastEmployerRelievingLetter || "",
        },
      };

      const apiCalls = [
        {
          url: `${process.env.REACT_APP_BACKEND_URL_HRM}/add-personal-details`,
          payload: personalDetailsPayload,
        },
        {
          url: `${process.env.REACT_APP_BACKEND_URL_HRM}/add-address-details`,
          payload: addressPayload,
        },
        {
          url: `${process.env.REACT_APP_BACKEND_URL_HRM}/add-emergency-contact`,
          payload: emergencyContactPayload,
        },
        {
          url: `${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-document`,
          payload: documentPayload,
        },
        {
          url: `${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-qualification`,
          payload: qualificationPayload,
        },
        {
          url: `${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-work-experience`,
          payload: workExperiencePayload,
        },
      ];

      let allApiCallsSuccessful = true;
      for (const call of apiCalls) {
        try {
          const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
            ?.stsTokenManager?.accessToken;

          const response = await fetch(call.url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(call.payload),
          });

          const result = await response.json();

          if (!response.ok && result.status !== "duplicate") {
            const message = result.message || "Unknown error";
            allApiCallsSuccessful = false;
            if (result.errors && typeof result.errors === "object") {
              const errorDetails = Object.entries(result.errors)
                .map(([key, val]) => `${val}`)
                .join("\n");
              throw new Error(errorDetails);
            }

            throw new Error(message);
          }
        } catch (err) {
          allApiCallsSuccessful = false;
          throw err; // Exit and skip update call
        }
      }

      const auth = getAuth();
      const user = auth.currentUser;
      const updatedBy = user?.email || "admin@example.com";

      if (allApiCallsSuccessful) {
        const leavePayload = [
          {
            UserEmail: employeeEmail,
            emergencyleave: emergencyLeave,
            plannedleave: plannedLeave,
            added_by: updatedBy,
            converted: true,
          },
        ];

        const leaveResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_LMS}/addleaves`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(leavePayload),
          }
        );

        if (!leaveResponse.ok) {
          allApiCallsSuccessful = false;
          const errorData = await leaveResponse.json();
          throw new Error(
            `Failed to add leaves: ${errorData.message || "Unknown error"}`
          );
        }
      }
      if (allApiCallsSuccessful) {
        const emailPayload = {
          name: application.name || "",
          position: application.job_title || "",
          start_date: joiningDate,
          manager_name: application.reporting_manager || "Your Team Lead",
          email: application.email || "",
          corporate_email: employeeEmail,
          temp_password: employeePassword,
        };

        const emailResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/send-onboarding-details-email`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(emailPayload),
          }
        );

        if (!emailResponse.ok) {
          console.warn("Onboarding email could not be sent");
          allApiCallsSuccessful = false;
          const errorData = await emailResponse.json();
          throw new Error(
            `Failed to send onboarding email: ${
              errorData.message || "Unknown error"
            }`
          );
        }
      }

      // 5. Update application status to "Employeed" ONLY AFTER all other operations succeed
      if (allApiCallsSuccessful) {
        const updateResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/job-applications/update/${id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
              status: "Employeed",
              updated_by: getAuth().currentUser.email,
              comment: "Converted to employee",
              app_id: application.id,
              converted: true,
            }),
          }
        );

        if (!updateResponse.ok) {
          const errorData = await updateResponse.json();
          throw new Error(
            `Failed to update application status: ${
              errorData.message || "Unknown error"
            }`
          );
        }
      }

      setDialogTitle("Success");
      setDialogMessage("Employee converted successfully!");
      setDialogOpen(true);
      setConfirmDialogOpen(false);
      setOpenConvertDialog(false);
      await fetchApplication();
      navigate("/job_application");
    } catch (error) {
      console.error("Conversion error:", error);
      let targetTab = activeTab;

      const lines = error.message?.split("\n") || [];
      for (let line of lines) {
        const fieldMatch = line.match(/^([A-Za-z0-9_]+)/);
        if (fieldMatch) {
          const fieldName = fieldMatch[1];
          const matchedTab = getTabByField(fieldName);
          if (matchedTab) {
            targetTab = matchedTab;
          } else {
            targetTab = "basic";
          }
        }
      }

      setActiveTab(targetTab);
      setDialogTitle("Opps Error Ocurred ..!");
      setDialogMessage(error.message || "Something went wrong.");
      setDialogOpen(true);

      if (employeeEmail) {
        await deleteEmployeeDataByEmail(employeeEmail);
      }
    } finally {
      setConverting(false);
    }
  };

  useEffect(() => { }, [activeTab]);

  const sortByDateDesc = (a, b) => {
    const dateA = new Date(
      (a.date || "").replace(" at ", " ").replace(" UTC+5:30", "")
    );
    const dateB = new Date(
      (b.date || "").replace(" at ", " ").replace(" UTC+5:30", "")
    );
    return dateB - dateA;
  };

  const commentList = Array.isArray(application?.Comment)
    ? application.Comment
    : [];

  const statusComments = commentList
    .filter((c) => c.statuscomment)
    .sort(sortByDateDesc);

  const formComments = commentList
    .filter((c) => c.formcomment)
    .sort(sortByDateDesc);

  const otpComments = commentList
    .filter((c) => c.otpcomment)
    .sort(sortByDateDesc);

  const normalComments = commentList
    .filter((c) => !c.statuscomment && !c.formcomment && !c.otpcomment)
    .sort(sortByDateDesc);

  const orderedComments = [
    ...statusComments,
    ...formComments,
    ...otpComments,
    ...normalComments,
  ].sort(sortByDateDesc);

  return (
    <Box>
      <Box sx={{ width: "100%", px: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
          sx={{
            mb: 1,
            px: 2,
            ".MuiTabs-indicator": {
              backgroundColor: colors.greenAccent[600],
            },
          }}
        >
          {applicationTabs.map((tab) => (
            <Tab
              key={tab.key}
              label={tab.label}
              value={tab.key}
              sx={{
                textTransform: "none",
                fontSize: "18px",
                fontWeight: activeTab === tab.key ? "bold" : 800,
                color:
                  activeTab === tab.key
                    ? colors.greenAccent[600]
                    : colors.primary[300],
                "&.Mui-selected": {
                  color: colors.greenAccent[600], // Active tab color
                  fontWeight: "bold", // Active tab bold
                },
                "&:hover": {
                  color: colors.greenAccent[400], // Hover color
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          minHeight: "100vh",
          overflowY: "auto",
          p: 3,
          display: "flex",
          justifyContent: "center",
          mt: 6,
        }}
      >
        {activeTab === "basic" && (
          <Paper
            elevation={4}
            sx={{
              width: "1100px",
              height: "fit-content",
              maxWidth: "100%",
              pt: 2,
              pb: 4,
              borderRadius: 3,
              backgroundColor: colors.primary[400],
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, pl: 2 }}>
              Application ID:{" "}
              <span style={{ color: "gray", fontWeight: "normal" }}>{id} </span>
            </Typography>

            <Box sx={{ width: "100%" }}>
              <Divider sx={{ borderBottomWidth: 2, borderColor: "gray" }} />
            </Box>

            {loading || !application ? (
              <Typography>Loading...</Typography>
            ) : (
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 3,
                  display: "flex",
                  maxWidth: "900px",
                  mx: "auto",
                  pr: 2,
                  alignItems: "flex-start",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Name"
                    variant="outlined"
                    fullWidth
                    value={application.name || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Applied Position"
                    variant="outlined"
                    fullWidth
                    value={application.job_title || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Mobile No."
                    variant="outlined"
                    fullWidth
                    value={application.mobile_no || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel
                      sx={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": { color: colors.grey[100] },
                        "&.MuiInputLabel-shrink": { color: colors.grey[100] },
                      }}
                    >
                      Status
                    </InputLabel>

                    <Select
                      label="Status"
                      value={application.status}
                      onChange={(e) => {
                        const newStatus = e.target.value;
                        setVisualStatusLabel(newStatus);
                        if (responseLabelTimer) {
                          clearTimeout(responseLabelTimer);
                          setResponseLabelTimer(null);
                        }

                        setApplication((prev) => ({
                          ...prev,
                          status: newStatus,
                          StatusChange: {
                            fromStatus: prev.status,
                            toStatus: newStatus,
                            StatusChange: true,
                          },
                        }));
                      }}
                      disabled={isDropdownDisabled}
                      sx={{
                        borderRadius: "8px",
                        color: colors.grey[100],
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        ".MuiSelect-icon": {
                          color: colors.grey[100],
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            color: colors.grey[100],
                            borderRadius: "8px",
                            background: colors.primary[400],
                            "&::before, &::after": {
                              display: "none",
                            },
                          },
                        },
                        MenuListProps: {
                          disableAutoFocusItem: true,
                        },
                      }}
                      renderValue={() => {
                        return (
                          displayLabelMap[application.status] ||
                          application.status
                        );
                      }}
                    >
                      {dropdownOptions.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          disabled={item.disabled}
                          disableRipple
                          sx={{
                            backgroundColor: "transparent !important",
                            "&:hover": {
                              backgroundColor: colors.greenAccent[800],
                            },
                            "&.Mui-selected": {
                              backgroundColor: "transparent !important",
                              color: colors.grey[100],
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: colors.greenAccent[800],
                            },
                          }}
                        >
                          {displayLabelMap[item.value] || item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    value={application.email || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Highest Qualification"
                    variant="outlined"
                    fullWidth
                    value={application.highestQualification || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Current Place"
                    variant="outlined"
                    fullWidth
                    value={application.current_city || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Native Place"
                    variant="outlined"
                    fullWidth
                    value={application.native_place || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Source"
                    variant="outlined"
                    fullWidth
                    value={application.source || "website"}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="current CTC"
                    variant="outlined"
                    fullWidth
                    value={application.current_ctc || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="expected CTC"
                    variant="outlined"
                    fullWidth
                    value={application.expected_ctc || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Resume"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(application.CV || "")}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor:
                          application.CV && application.CV !== "No File"
                            ? "pointer"
                            : "not-allowed",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() => {
                      // console.log('TextField clicked, URL:', application.CV);
                      application.CV &&
                        application.CV !== "No File" &&
                        handleOpenModal(application.CV);
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": { color: colors.grey[100] },
                        "&.MuiInputLabel-shrink": { color: colors.grey[100] },
                      },
                    }}
                  />
                </Grid>

              </Grid>
            )}

            <>
              {/* Save Button */}
              <Box
                display="flex"
                gap={1}
                justifyContent="flex-end"
                sx={{ mt: 3, mr: 15, mb: 3 }}
              >
                {confirmedStatus === "Onboarding" && (
                  <Button
                    variant="contained"
                    sx={{
                      width: 200,
                      fontWeight: "bold",
                      backgroundColor: colors.greenAccent[600],
                      "&:hover": {
                        backgroundColor: colors.greenAccent[700],
                      },
                    }}
                    onClick={() => setOpenConvertDialog(true)}
                  >
                    Convert to Employee
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="success"
                  onClick={saveApplication}
                  sx={{ width: 150, fontWeight: "bold" }}
                  disabled={loading || isSaving} // Disable during loading or saving
                >
                  {isSaving ? (
                    <>
                      Saving{" "}
                      <CircularProgress
                        size={20}
                        sx={{ ml: 1, color: colors.grey[100] }}
                      />
                    </>
                  ) : (
                    "Save"
                  )}
                </Button>

                <Button
                  variant="contained"
                  onClick={BackApplication}
                  sx={{
                    width: 150,
                    fontWeight: "bold",
                    backgroundColor: colors.primary[300],
                    color: "#fff", // optional: set text color
                    "&:hover": {
                      backgroundColor: colors.primary[200], // hover effect
                    },
                  }}
                  disabled={loading}
                >
                  Back
                </Button>
              </Box>

              <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <Alert
                  onClose={() => setSnackbarOpen(false)}
                  severity={snackbarSeverity}
                  variant="filled"
                  sx={{ width: "100%", fontFamily: "Lexend", fontSize: "15px" }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>

              <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                PaperProps={{
                  sx: {
                    width: 490,
                    maxWidth: "90vw",
                    fontWeight: 500,
                    padding: 3,
                    fontSize: "22px",
                    fontFamily: "Lexend",
                    borderRadius: "19px",
                  },
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography variant="h4" gutterBottom>
                    {dialogTitle}
                  </Typography>
                  <Typography sx={{ mb: 3 }}>{dialogMessage}</Typography>
                  <Box textAlign="right">
                    <Button
                      variant="contained"
                      onClick={() => setDialogOpen(false)}
                      sx={{ fontSize: "16px" }}
                    >
                      OK
                    </Button>
                  </Box>
                </Box>
              </Dialog>
              {/* Comments Section */}
              <Box display="flex" justifyContent="center">
                <Box
                  p={2}
                  mb={2}
                  mx={2}
                  borderRadius="12px"
                  sx={{
                    width: "900px",
                    maxWidth: "100%",
                    border: `1px solid ${colors.primary[300]}`,
                  }}
                >
                  {/* Header / Add Comment section above comments */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={orderedComments.length > 0 ? 2 : 0}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      <CommentIcon sx={{ color: colors.grey[100] }} />
                      <Typography variant="h5" fontWeight="bold">
                        Comments {orderedComments.length > 0 ? `(${orderedComments.length})` : ""}
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setNewCommentText("");
                        setOpenCommentDialog(true);
                      }}
                      sx={{
                        fontWeight: "bold",
                        backgroundColor: colors.blueAccent[600],
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: colors.blueAccent[700],
                        },
                      }}
                    >
                      Add Comment
                    </Button>
                  </Box>

                  {orderedComments.length > 0 ? (
                    <>
                      <Divider sx={{ mb: 2, borderColor: colors.primary[300] }} />
                      {orderedComments.map((commentData, index) => {
                        let IconComponent = CommentIcon;
                        if (commentData.otpcomment) {
                          IconComponent = SecurityIcon;
                        } else if (commentData.statuscomment) {
                          IconComponent = AssignmentTurnedInIcon;
                        } else if (commentData.formcomment) {
                          IconComponent = CheckCircleIcon;
                        }

                        return (
                          <Box
                            key={index}
                            display="flex"
                            gap={2}
                            mb={2}
                            alignItems="flex-start"
                          >
                            {/* Icon */}
                            <IconComponent color="action" />

                            <Box flex={1}>
                              {/* Header */}
                              <Box display="flex" justifyContent="space-between">
                                <Typography fontWeight={600}>
                                  {commentData.User} added
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {getTimeAgo(commentData.date)}
                                </Typography>
                              </Box>

                              {/* Order: 1. Status */}
                              {commentData.statuscomment && (
                                <Typography
                                  mt={0.5}
                                  fontStyle="italic"
                                  color="text.secondary"
                                >
                                  {commentData.statuscomment}
                                </Typography>
                              )}

                              {/* Order: 2. Form */}
                              {commentData.formcomment && (
                                <Typography
                                  mt={0.5}
                                  fontStyle="italic"
                                  color="text.secondary"
                                >
                                  {commentData.formcomment}
                                </Typography>
                              )}

                              {/* Order: 3. OTP message */}
                              {commentData.otpcomment && (
                                <Typography
                                  mt={0.5}
                                  fontStyle="italic"
                                  color="text.secondary"
                                >
                                  {commentData.otpcomment}
                                </Typography>
                              )}

                              {/* Order: 4. OTP value box */}
                              {commentData.Otp && (
                                <Box
                                  mt={1}
                                  p={1.5}
                                  borderRadius="6px"
                                  width="100%"
                                  sx={{
                                    backgroundColor: colors.blueAccent[900],
                                    border: `1px solid ${colors.primary[100]}`,
                                  }}
                                >
                                  <Typography fontWeight={500}>
                                    OTP:{" "}
                                    <span style={{ fontWeight: 700 }}>
                                      {commentData.Otp}
                                    </span>
                                  </Typography>
                                </Box>
                              )}

                              {/* Order: 5. Additional comment */}
                              {commentData.comment && (
                                <Box
                                  mt={1}
                                  p={1.5}
                                  borderRadius="6px"
                                  width="100%"
                                  sx={{
                                    backgroundColor: colors.blueAccent[900],
                                    border: `1px solid ${colors.primary[100]}`,
                                  }}
                                >
                                  <Typography>{commentData.comment}</Typography>
                                </Box>
                              )}
                            </Box>
                          </Box>
                        );
                      })}
                    </>
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1, fontStyle: "italic", textAlign: "center" }}
                    >
                      No comments yet.
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Add Comment Dialog */}
              <Dialog
                open={openCommentDialog}
                onClose={handleCloseCommentDialog}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                  sx: {
                    borderRadius: "12px",
                    backgroundColor: colors.primary[400],
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  Add Comment
                  <IconButton
                    onClick={handleCloseCommentDialog}
                    disabled={isAddingComment}
                    sx={{ color: colors.grey[100] }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    value={newCommentText}
                    onChange={(e) => setNewCommentText(e.target.value)}
                    placeholder="Enter your comments here..."
                    disabled={isAddingComment}
                    InputProps={{
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                  <Button
                    onClick={handleCloseCommentDialog}
                    disabled={isAddingComment}
                    sx={{
                      color: colors.grey[100],
                      fontWeight: "bold",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleAddComment}
                    disabled={isAddingComment || !newCommentText.trim()}
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: colors.blueAccent[600],
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: colors.blueAccent[700],
                      },
                      "&.Mui-disabled": {
                        backgroundColor: colors.primary[300],
                        color: colors.grey[400],
                      },
                    }}
                  >
                    {isAddingComment ? (
                      <>
                        Adding...{" "}
                        <CircularProgress
                          size={18}
                          sx={{ ml: 1, color: "#fff" }}
                        />
                      </>
                    ) : (
                      "Add Comment"
                    )}
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth={false}
                PaperProps={{
                  sx: {
                    width: "95vw",
                    height: "95vh",
                    maxWidth: "none",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 2,
                  }}
                >
                  File Preview
                  {isRefreshing && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={16} />
                      <Typography variant="caption">Refreshing...</Typography>
                    </Box>
                  )}
                  <IconButton onClick={handleCloseModal}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: "100%",
                    overflow: "hidden",
                  }}
                >
                  {renderPreview(previewUrl)}

                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2 }}
                    href={previewUrl}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    disabled={isRefreshing || isPreviewLoading} // Disable during refresh/loading
                  >
                    {isRefreshing ? "Refreshing..." : "Download"}
                  </Button>
                </DialogContent>
              </Dialog>
            </>
          </Paper>
        )}

        {activeTab === "Job Preferences" && (
          <Paper
            elevation={4}
            sx={{
              width: "100%",
              maxWidth: "1100px",
              height: "fit-content",
              pt: 2,
              pb: 4,
              borderRadius: 3,
              backgroundColor: colors.primary[400],
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              mx: "auto",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, pl: 2 }}>
              Application ID:{" "}
              <span style={{ color: "gray", fontWeight: "normal" }}>{id} </span>
            </Typography>

            <Box sx={{ width: "100%" }}>
              <Divider sx={{ borderBottomWidth: 2, borderColor: "gray" }} />
            </Box>

            {loading || !application ? (
              <Typography>Loading...</Typography>
            ) : (
              <Grid
                container
                spacing={2}
                sx={{ mt: 3, pl: 3, width: "100%", textAlign: "left" }}
              >
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Name"
                    variant="outlined"
                    fullWidth
                    value={application.name || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Do you want to work with a small org?"
                    variant="outlined"
                    fullWidth
                    value={
                      application.Do_you_want_to_work_with_a_small_org || " "
                    }
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Describe your roles and responsibilities in your current project"
                    variant="outlined"
                    fullWidth
                    value={application.Roles_and_responsibilities || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Why do you think you should apply for this position?"
                    variant="outlined"
                    fullWidth
                    value={application.Why_apply || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Where do you see yourself after 5 years?"
                    variant="outlined"
                    fullWidth
                    value={application.Five_year_goal || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Preferred Location"
                    variant="outlined"
                    fullWidth
                    value={application.Preferred_Location || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Current CTC (Yearly)"
                    variant="outlined"
                    fullWidth
                    value={application.current_ctc || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Current Take Home (Monthly)"
                    variant="outlined"
                    fullWidth
                    value={application.Current_Take_Home_Monthly || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Expected CTC (Yearly)"
                    variant="outlined"
                    fullWidth
                    value={application.expected_ctc || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Expected CTC Negotiable"
                    variant="outlined"
                    fullWidth
                    value={application.Expected_CTC_Negotiable || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Total Experience"
                    variant="outlined"
                    fullWidth
                    value={application.Total_Experience || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Relevant Experience (For Key Skills)"
                    variant="outlined"
                    fullWidth
                    value={application.Relevant_Experience || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Earliest Joining (in days)"
                    variant="outlined"
                    fullWidth
                    value={application.Earliest_Joining_days || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Holding any other offer currently?"
                    variant="outlined"
                    fullWidth
                    value={application.Holding_other_offer || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="highest Qualification"
                    variant="outlined"
                    fullWidth
                    value={application.highestQualification || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <TextField
                    label="professional Reference 1"
                    variant="outlined"
                    fullWidth
                    value={application.professionalReference1 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Reference number 1"
                    variant="outlined"
                    fullWidth
                    value={application.referencenumber1 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Reference email 1"
                    variant="outlined"
                    fullWidth
                    value={application.referenceemail1 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={5}>
                  <TextField
                    label="professional Reference 2"
                    variant="outlined"
                    fullWidth
                    value={application.professionalReference2 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Reference number 2"
                    variant="outlined"
                    fullWidth
                    value={application.renferencenumber2 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Reference email 2"
                    variant="outlined"
                    fullWidth
                    value={application.referenceemail2 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    label="Describe yourself in a few words."
                    variant="outlined"
                    fullWidth
                    value={application.Describe_yourself || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Introduction Video"
                    variant="outlined"
                    fullWidth
                    value={getFileNameFromUrl(
                      application.Introduction_video || " "
                    )}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <VisibilityIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() =>
                      handleOpenModal(application.Introduction_video)
                    }
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": { color: colors.grey[100] },
                        "&.MuiInputLabel-shrink": { color: colors.grey[100] },
                      },
                    }}
                  />
                </Grid>

                <Dialog
                  open={openModal}
                  onClose={handleCloseModal}
                  maxWidth={false}
                  PaperProps={{
                    sx: {
                      width: "55vw",
                      height: "90vh",
                      maxWidth: "none",
                    },
                  }}
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      pr: 2,
                    }}
                  >
                    File Preview
                    <IconButton onClick={handleCloseModal}>
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {renderPreview(previewUrl)}

                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ mt: 2 }}
                      href={previewUrl}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </Button>
                  </DialogContent>
                </Dialog>
              </Grid>
            )}
          </Paper>
        )}

        {activeTab === "Documents" && (
          <Paper
            elevation={4}
            sx={{
              width: "1000px",
              height: "fit-content",
              maxWidth: "100%",
              pt: 2,
              pb: 4,
              borderRadius: 3,
              backgroundColor: colors.primary[400],
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, pl: 2 }}>
              Application ID:{" "}
              <span style={{ color: "gray", fontWeight: "normal" }}>{id} </span>
            </Typography>

            <Box sx={{ width: "100%" }}>
              <Divider sx={{ borderBottomWidth: 2, borderColor: "gray" }} />
            </Box>

            {loading || !application ? (
              <Typography>Loading...</Typography>
            ) : (
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 3,
                  display: "flex",
                  maxWidth: "900px",
                  mx: "auto",
                  pr: 2,
                  alignItems: "flex-start",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Latest Pay Slip"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(application.latestPaySlip || " ")}
                    disabled={!application.latestPaySlip}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() => handleOpenModal(application.latestPaySlip)}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Last Appointment Letter"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(
                      application.lastAppointmentLetter || ""
                    )}
                    disabled={!application.lastAppointmentLetter}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() =>
                      handleOpenModal(application.lastAppointmentLetter)
                    }
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Highest Qualification"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(
                      application.degreeCertificate || ""
                    )}
                    disabled={!application.degreeCertificate}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() =>
                      handleOpenModal(application.degreeCertificate)
                    }
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Identity Proof"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(
                      application.identityProof || "  "
                    )}
                    disabled={!application.identityProof}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() => handleOpenModal(application.identityProof)}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Photograph"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(application.photograph || "  ")}
                    disabled={!application.photograph}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() => handleOpenModal(application.photograph)}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Last Employer Relieving Letter"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(
                      application.lastEmployerRelievingLetter || "  "
                    )}
                    disabled={!application.lastEmployerRelievingLetter}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() =>
                      handleOpenModal(application.lastEmployerRelievingLetter)
                    }
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Experience Letter"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(
                      application.lastEmployerExperienceLetter || ""
                    )}
                    disabled={!application.lastEmployerExperienceLetter}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() =>
                      handleOpenModal(application.lastEmployerExperienceLetter)
                    }
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Aadhar Card"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(application.aadharCard || "")}
                    disabled={!application.aadharCard}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() => handleOpenModal(application.aadharCard)}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="pan Card"
                    variant="outlined"
                    fullWidth
                    placeholder="No File"
                    value={getFileNameFromUrl(application.panCard || "")}
                    disabled={!application.panCard}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        cursor: "pointer",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                      startAdornment: (
                        <InsertDriveFileIcon sx={{ color: "#666", mr: 1 }} />
                      ),
                    }}
                    onClick={() => handleOpenModal(application.panCard)}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Dialog
                  open={openModal}
                  onClose={handleCloseModal}
                  maxWidth={false}
                  PaperProps={{
                    sx: {
                      width: "55vw",
                      height: "90vh",
                      maxWidth: "none",
                    },
                  }}
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      pr: 2,
                    }}
                  >
                    File Preview
                    <IconButton onClick={handleCloseModal}>
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {renderPreview(previewUrl)}

                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ mt: 2 }}
                      href={previewUrl}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </Button>
                  </DialogContent>
                </Dialog>
              </Grid>
            )}
          </Paper>
        )}

        {activeTab === "Employee Information" && (
          <Paper
            elevation={4}
            sx={{
              width: "1100px",
              height: "fit-content",
              maxWidth: "100%",
              pt: 2,
              pb: 4,
              borderRadius: 3,
              backgroundColor: colors.primary[400],
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, pl: 2 }}>
              Application ID:{" "}
              <span style={{ color: "gray", fontWeight: "normal" }}>{id} </span>
            </Typography>

            <Box sx={{ width: "100%" }}>
              <Divider sx={{ borderBottomWidth: 2, borderColor: "gray" }} />
            </Box>

            {loading || !application ? (
              <Typography>Loading...</Typography>
            ) : (
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 3,
                  display: "flex",
                  maxWidth: "900px",
                  mx: "auto",
                  pr: 2,
                  alignItems: "flex-start",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="legal Name"
                    variant="outlined"
                    fullWidth
                    value={application.legalName || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Gender"
                    variant="outlined"
                    fullWidth
                    value={application.gender || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Date of Birth"
                    variant="outlined"
                    fullWidth
                    value={application.dateOfBirth || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Marital Status"
                    variant="outlined"
                    fullWidth
                    value={application.maritalStatus || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Languages Known"
                    variant="outlined"
                    fullWidth
                    value={application.languagesKnown || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Present Address"
                    variant="outlined"
                    fullWidth
                    value={application.presentAddress || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Permanent Address"
                    variant="outlined"
                    fullWidth
                    value={application.permanentAddress || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Native Place"
                    variant="outlined"
                    fullWidth
                    value={application.nativePlace || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="College Name"
                    variant="outlined"
                    fullWidth
                    value={application.collegeName || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="University Name"
                    variant="outlined"
                    fullWidth
                    value={application.universityName || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Year of Passing"
                    variant="outlined"
                    fullWidth
                    value={application.yearOfPassing || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Key Skills"
                    variant="outlined"
                    fullWidth
                    value={application.keySkills || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Last Employer Relieving Date"
                    variant="outlined"
                    fullWidth
                    value={application.lastEmployerRelievingDate || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Blood Group"
                    variant="outlined"
                    fullWidth
                    value={application.bloodGroup || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <TextField
                    label="Contact Name 1"
                    variant="outlined"
                    fullWidth
                    value={application.emergencyContact1 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Relation 1"
                    variant="outlined"
                    fullWidth
                    value={application.relation1 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Emergency  Contact Number 1"
                    variant="outlined"
                    fullWidth
                    value={application.emergencyContactNumber1 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <TextField
                    label=" Contact Name 2"
                    variant="outlined"
                    fullWidth
                    value={application.emergencyContact2 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Relation 2"
                    variant="outlined"
                    fullWidth
                    value={application.relation2 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="emergency Contact Number 2"
                    variant="outlined"
                    fullWidth
                    value={application.emergencyContactNumber2 || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Family Contact Number"
                    variant="outlined"
                    fullWidth
                    value={application.familyContactNumber || " "}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100],
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100],
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </Paper>
        )}
      </Box>

      <Dialog
        open={openConvertDialog}
        onClose={() => !converting && setOpenConvertDialog(false)}
      >
        <DialogTitle>Convert to Employee</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Enter employee credentials:
          </DialogContentText>
          <TextField
            label="Corporate Email"
            type="email"
            fullWidth
            variant="outlined"
            value={employeeEmail}
            onChange={(e) => setEmployeeEmail(e.target.value)}
            disabled={converting}
            InputProps={{
              sx: {
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                fontWeight: "bold",
                fontSize: "18px",
                color: colors.grey[100],
                "&.Mui-focused": { color: colors.grey[100] },
                "&.MuiInputLabel-shrink": { color: colors.grey[100] },
              },
            }}
          />
          <TextField
            margin="dense"
            label="Temporary Password"
            type="password"
            fullWidth
            variant="outlined"
            value={employeePassword}
            onChange={(e) => setEmployeePassword(e.target.value)}
            disabled={converting}
            InputProps={{
              sx: {
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                fontWeight: "bold",
                fontSize: "18px",
                color: colors.grey[100],
                "&.Mui-focused": { color: colors.grey[100] },
                "&.MuiInputLabel-shrink": { color: colors.grey[100] },
              },
            }}
          />
          <TextField
            margin="dense"
            label="Joining Date"
            type="date"
            fullWidth
            variant="outlined"
            value={joiningDate}
            onChange={(e) => setJoiningDate(e.target.value)}
            disabled={converting}
            InputProps={{
              sx: {
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                paddingRight: "10px",
              },
            }}
            InputLabelProps={{
              shrink: true,
              sx: {
                fontWeight: "bold",
                fontSize: "18px",
                color: colors.grey[100],
                "&.Mui-focused": { color: colors.grey[100] },
                "&.MuiInputLabel-shrink": {
                  color: colors.grey[100],
                  transform: "translate(14px, -6px) scale(0.75)",
                },
              },
            }}
          />
          <TextField
            margin="dense"
            label="Emergency Leave"
            fullWidth
            variant="outlined"
            value={leaveLoading ? "Loading..." : emergencyLeave}
            InputProps={{
              readOnly: true,
              sx: {
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                fontWeight: "bold",
                fontSize: "18px",
                color: colors.grey[100],
                "&.Mui-focused": { color: colors.grey[100] },
                "&.MuiInputLabel-shrink": { color: colors.grey[100] },
              },
            }}
          />
          <TextField
            margin="dense"
            label="Planned Leave"
            fullWidth
            variant="outlined"
            value={leaveLoading ? "Loading..." : plannedLeave}
            InputProps={{
              readOnly: true,
              sx: {
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                fontWeight: "bold",
                fontSize: "18px",
                color: colors.grey[100],
                "&.Mui-focused": { color: colors.grey[100] },
                "&.MuiInputLabel-shrink": { color: colors.grey[100] },
              },
            }}
          />

          <FormControl
            fullWidth
            variant="outlined"
            margin="dense"
            disabled={converting}
          >
            <InputLabel
              sx={{
                fontWeight: "bold",
                fontSize: "18px",
                color: colors.grey[100],
                "&.Mui-focused": { color: colors.grey[100] },
                "&.MuiInputLabel-shrink": { color: colors.grey[100] },
              }}
            >
              Branch
            </InputLabel>
            <Select
              value={branchId}
              onChange={(e) => setBranchId(e.target.value)}
              label="Branch"
              sx={{
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#aaa" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#aaa !important",
                },
                color: colors.grey[100],
              }}
            >
              <MenuItem value="Ahmedabad">Ahmedabad</MenuItem>
              <MenuItem value="Pune">Pune</MenuItem>
            </Select>
          </FormControl>
          {/* Leave Calculation Section */}
          <Box
            sx={{
              mt: 2,
              p: 2,
              border: `1px solid ${colors.grey[700]}`,
              borderRadius: "8px",
              backgroundColor: colors.primary[400],
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: colors.grey[100], mb: 1 }}
            >
              Leave Calculation Details
            </Typography>

            {/* Explanation */}
            <Typography
              variant="body2"
              sx={{ color: colors.grey[300], lineHeight: 1.6, mb: 2 }}
            >
              {getLeaveCalculationExplanation()}
            </Typography>

            {/* Joining Date Display */}
            <Typography variant="body2" sx={{ color: colors.grey[300], mb: 2 }}>
              Joining Date:{" "}
              <strong>
                {getLeaveCalculationTableData().joiningDateFormatted ||
                  "Not selected"}
              </strong>
            </Typography>

            {/* PL Calculation Schema */}
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", color: colors.grey[100], mb: 1 }}
            >
              PL Calculation Schema (within the joining quarter):
            </Typography>
            <TableContainer sx={{ overflowX: "auto", mb: 3 }}>
              <Table
                sx={{
                  minWidth: "100%",
                  border: `1px solid ${colors.grey[700]}`,
                }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: colors.primary[500] }}>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Days Since Quarter Start
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      PL Allocated
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getLeaveCalculationTableData().canCalculate &&
                    getLeaveCalculationTableData().plSchemaData ? (
                    getLeaveCalculationTableData().plSchemaData.map(
                      (row, index) => (
                        <TableRow
                          key={index}
                          sx={{ backgroundColor: colors.primary[400] }}
                        >
                          <TableCell
                            sx={{
                              color: colors.grey[100],
                              border: `1px solid ${colors.grey[700]}`,
                              textAlign: "center",
                            }}
                          >
                            {row.daysRange}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: colors.grey[100],
                              border: `1px solid ${colors.grey[700]}`,
                              textAlign: "center",
                            }}
                          >
                            {row.allocation}
                          </TableCell>
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        sx={{
                          color: colors.grey[300],
                          textAlign: "center",
                          border: `1px solid ${colors.grey[700]}`,
                        }}
                      >
                        Please select a joining date to view schema.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Note for PL */}
            <Typography variant="body2" sx={{ color: colors.grey[300], mb: 3 }}>
              • Add full PLs for any <strong>remaining quarters</strong> in the
              year.
            </Typography>

            {/* EL Calculation Schema */}
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", color: colors.grey[100], mb: 1 }}
            >
              EL Calculation Schema (within the joining half-year):
            </Typography>
            <TableContainer sx={{ overflowX: "auto", mb: 3 }}>
              <Table
                sx={{
                  minWidth: "100%",
                  border: `1px solid ${colors.grey[700]}`,
                }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: colors.primary[500] }}>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Days Since Half-Year Start
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      EL Allocated
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getLeaveCalculationTableData().canCalculate &&
                    getLeaveCalculationTableData().elSchemaData ? (
                    getLeaveCalculationTableData().elSchemaData.map(
                      (row, index) => (
                        <TableRow
                          key={index}
                          sx={{ backgroundColor: colors.primary[400] }}
                        >
                          <TableCell
                            sx={{
                              color: colors.grey[100],
                              border: `1px solid ${colors.grey[700]}`,
                              textAlign: "center",
                            }}
                          >
                            {row.daysRange}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: colors.grey[100],
                              border: `1px solid ${colors.grey[700]}`,
                              textAlign: "center",
                            }}
                          >
                            {row.allocation}
                          </TableCell>
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        sx={{
                          color: colors.grey[300],
                          textAlign: "center",
                          border: `1px solid ${colors.grey[700]}`,
                        }}
                      >
                        Please select a joining date to view schema.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Note for EL */}
            <Typography variant="body2" sx={{ color: colors.grey[300], mb: 3 }}>
              • Add full EL for <strong>remaining half of the year</strong> if
              applicable.
            </Typography>

            {/* Main Calculation Table */}
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", color: colors.grey[100], mb: 1 }}
            >
              Your Leave Calculation:
            </Typography>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table
                sx={{
                  minWidth: "100%",
                  border: `1px solid ${colors.grey[700]}`,
                }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: colors.primary[500] }}>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Leave Type
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Annual Allocation
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Period
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Days Since Period Start
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Allocation for Current Period
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Remaining Periods
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Allocation for Remaining Periods
                    </TableCell>
                    <TableCell
                      sx={{
                        color: colors.grey[100],
                        fontWeight: "bold",
                        border: `1px solid ${colors.grey[700]}`,
                        textAlign: "center",
                      }}
                    >
                      Total Leave
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getLeaveCalculationTableData().canCalculate ? (
                    getLeaveCalculationTableData().data.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{ backgroundColor: colors.primary[400] }}
                      >
                        <TableCell
                          sx={{
                            color: colors.grey[100],
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.leaveType}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: colors.grey[100],
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.annual}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: colors.grey[100],
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.period}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: colors.grey[100],
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.daysSincePeriodStart}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: colors.grey[100],
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.allocationCurrent}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: colors.grey[100],
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.remainingPeriods}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: colors.grey[100],
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.allocationRemaining}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: colors.greenAccent[400],
                            fontWeight: "bold",
                            border: `1px solid ${colors.grey[700]}`,
                            textAlign: "center",
                          }}
                        >
                          {row.total}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        sx={{
                          color: colors.grey[300],
                          textAlign: "center",
                          border: `1px solid ${colors.grey[700]}`,
                        }}
                      >
                        Please select a joining date to calculate leaves.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenConvertDialog(false)}
            sx={{ color: colors.grey[100] }}
            disabled={converting}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setConfirmDialogOpen(true);
            }}
            color="success"
            variant="contained"
            disabled={
              converting ||
              !employeeEmail ||
              !employeePassword ||
              !branchId ||
              !joiningDate
            }
          >
            {converting ? "Processing..." : "Continue"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmDialogOpen}
        onClose={() => !converting && setConfirmDialogOpen(false)}
      >
        <DialogTitle>Confirm Conversion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to convert this applicant to an employee?
          </DialogContentText>
          <DialogContentText sx={{ mt: 2, fontWeight: "bold" }}>
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDialogOpen(false)}
            sx={{ color: colors.grey[100] }}
            disabled={converting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConvertToEmployee}
            color="success"
            variant="contained"
            disabled={converting}
            sx={{
              backgroundColor: colors.greenAccent[600],
              "&:hover": {
                backgroundColor: colors.greenAccent[700],
              },
            }}
          >
            {converting ? "Processing..." : "Confirm Conversion"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default JobDetails;
